import { useState, useCallback } from 'react';
import { getApiUrl } from '../config/api';

const useApi = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async (url, options = {}) => {
        setLoading(true);
        setError(null);

        try {
            const token = localStorage.getItem('token');
            const headers = {
                'Content-Type': 'application/json',
                ...(token && { Authorization: `Bearer ${token}` }),
                ...options.headers,
            };
      
            const response = await fetch(getApiUrl(url), {
                ...options,
                headers,
            });

            if (response.status === 401) {
                // Clear user data and redirect to login
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/login';
                return; // Prevent further execution
            }

            if (!response.ok) {
                let errorMessage;
                try {
                    const errorData = await response.json();
                    errorMessage = errorData.message || 'Something went wrong';
                } catch {
                    errorMessage = 'Something went wrong';
                }
                throw new Error(errorMessage);
            }

            const data = await response.json();
            return data;
        } catch (err) {
            const errorMessage = err.message || 'An error occurred';
            setError(errorMessage);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        loading,
        error,
        fetchData,
    };
};

export default useApi; 